import axios from 'axios';
import config from 'config';
import { environment } from 'environments/environment';

export interface user {
    id: string;
    role: string;
    email: string;
    password: string;
}

export const getConfigAsync: any = async (tcu: any) => {
    let res: any;

    let body = {
        TCU: tcu
    };

    const getConfig = async () => {
        await axios
            .post(`${environment.apiBaseUrl}bdr/getConfig`, body, {
                headers: {
                    Authorization: `Bearer ${environment.authToken}`
                }
            })
            .then((response) => {
                res = response.data;
                return res;
            })
            .catch((err) => {
                console.log(err);
                console.log(err.message);
                console.log(err.code);
                throw err;
            });
    };

    await getConfig();
    return res;
};

export const updateConfigAsync: any = async (
    tcu: any,
    configuration: any,
    timeRunMode: any,
    diffLastEvent: any,
    bdrTimeout: any,
    mcuSource: any,
    tcuSource: any
) => {
    let res: any;

    let body = {
        TCU: tcu,
        Config: configuration,
        TimeRunMode: timeRunMode,
        DiffLastEvent: diffLastEvent,
        BDRTimeout: bdrTimeout,
        MCUSource: mcuSource,
        TCUSource: tcuSource
    };

    const updateConfig = async () => {
        await axios
            .post(`${environment.apiBaseUrl}bdr/updateConfig`, body, {
                headers: {
                    Authorization: `Bearer ${environment.authToken}`
                }
            })
            .then((response) => {
                res = response.data;
                return res;
            })
            .catch((err) => {
                console.log(err);
                console.log(err.message);
                console.log(err.code);
                throw err;
            });
    };

    await updateConfig();
    return res;
};

export const getTableAsync: any = async (tableName: any, SN: any, VTBs: any, SCUs: any, startTimeStamp: any, endTimeStamp: any) => {
    let res: any;

    let body = {
        TableName: tableName,
        SNs: SN,
        VTB: VTBs,
        SCU: SCUs,
        startTimeStamp: startTimeStamp,
        endTimeStamp: endTimeStamp
    };
    const getTable = async () => {
        await axios
            .post(`${environment.apiBaseUrl}bdr/table`, body, {
                headers: {
                    Authorization: `Bearer ${environment.authToken}`
                }
            })
            .then((response) => {
                res = response.data;
                return response.data;
            })
            .catch((err) => {
                console.log(err);
                console.log(err.message);
                console.log(err.code);
                throw err;
            });
    };

    await getTable();
    return res;
};

export const getTimestamps: any = async (tableName: any, SN: any, VTBs: any, SCUs: any, startTimeStamp: any, endTimeStamp: any) => {
    let res: any;
    let body = {
        TableName: tableName,
        SNs: SN,
        VTB: VTBs,
        SCU: SCUs,
        startTimeStamp: startTimeStamp,
        endTimeStamp: endTimeStamp
    };
    const getTable = async () => {
        await axios
            .post(`${environment.apiBaseUrl}bdr/gettimestamps`, body, {
                headers: {
                    Authorization: `Bearer ${environment.authToken}`
                }
            })
            .then((response) => {
                res = response.data;
                return response.data;
            })
            .catch((err) => {
                console.log(err);
                console.log(err.message);
                console.log(err.code);
                throw err;
            });
    };
    await getTable();
    return res;
};

export const sendDMRequest = async (sn: any) => {
    let response: any;

    let body = {
        SN: sn
    };

    const sendRequest = async () => {
        await axios
            .post(`${environment.apiBaseUrl}bdr/dm`, body, {
                headers: {
                    Authorization: `Bearer ${environment.authToken}`
                }
            })
            .then((res) => {
                console.log(res);
                // console.log(response.data.data);
                response = res.data.data;
                //return response.data.data;
            })
            .catch((err) => {
                console.log(err);
                console.log(err.message);
                console.log(err.code);
                throw err;
            });
    };
    await sendRequest();
    return response;
};

export default { getTableAsync, getTimestamps, sendDMRequest };
